export default "__VITE_ASSET__Dyf51_IB__"